import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["message"]
  static values = {
    duration: { type: Number, default: 4000 }
  }

  connect() {
    this.show()
  }

  show() {
    this.element.classList.remove('opacity-0', 'translate-y-2')
    this.element.classList.add('opacity-100', 'translate-y-0')
    
    setTimeout(() => {
      this.hide()
    }, this.durationValue)
  }

  hide() {
    this.element.classList.remove('opacity-100', 'translate-y-0')
    this.element.classList.add('opacity-0', 'translate-y-2')
    
    setTimeout(() => {
      this.element.remove()
    }, 300) // Match the transition duration
  }
} 